import {ScreenCoordinates} from './ScreenCoordinates';

export class Square {

  constructor(public topLeft: ScreenCoordinates, public width: number) {
  }

  get bottomRight() {
    return {
      x: this.topLeft.x + this.width,
      y: this.topLeft.y + this.width
    } as ScreenCoordinates
  }
  contains(point: ScreenCoordinates) {
    return point.x >= this.topLeft.x && point.x <= this.bottomRight.x &&
           point.y >= this.topLeft.y && point.y <= this.bottomRight.y;
  }
}
